import { Component, inject, input, OnInit, signal } from '@angular/core';
import { SessionService } from '@app/core/services/client-services/session-service/session.service';
import { AppStore } from '@app/stores/appStore';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { AdministrationUserDetails } from '../../../../api/models/administration-user-details';
import { AdministrationService } from '../../../../api/services/administration.service';
import { TranslateModule } from '@ngx-translate/core';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    imports: [TranslateModule],
})
export class UsersComponent implements OnInit {
    private appStore = inject(AppStore);
    orgKey = input.required<string>();
    userKey = input.required<string>();
    siteKey = input<string | undefined>();

    user = signal<AdministrationUserDetails | undefined>(undefined);

    constructor(
        private spinner: NgxSpinnerService,
        private adminService: AdministrationService,
        private sessionService: SessionService
    ) {}

    async ngOnInit() {
        await this.getUser();
    }

    async getUser() {
        await this.spinner.show();
        try {
            if (this.sessionService.isOrganizationAdmin) {
                this.user.set(await lastValueFrom(
                    this.adminService.getAdministrationOrganizationUser({
                        organizationKey: this.orgKey(),
                        userKey: this.userKey(),
                    })
                ));
            } else {
                const siteKey = this.siteKey()
                    ? this.siteKey()
                    : this.appStore.currentOrganizationSiteKey();
                this.user.set(await lastValueFrom(
                    this.adminService.getAdministrationOrganizationSiteUser({
                        organizationSiteKey: siteKey,
                        userKey: this.userKey(),
                    })
                ));
            }
        } catch (error) {
        } finally {
            await this.spinner.hide();
        }
    }
}
